import { render, staticRenderFns } from "./PvcTab.vue?vue&type=template&id=2c2c5fd6&"
import script from "./PvcTab.vue?vue&type=script&lang=js&"
export * from "./PvcTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports